// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DragOutlinedSvg from "@ant-design/icons-svg/es/asn/DragOutlined";
import AntdIcon from '../components/AntdIcon';

var DragOutlined = function DragOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DragOutlinedSvg
  }));
};

DragOutlined.displayName = 'DragOutlined';
export default React.forwardRef(DragOutlined);